import { render, staticRenderFns } from "./ListaPaquetesApp.vue?vue&type=template&id=4a6d7c82"
import script from "./ListaPaquetesApp.vue?vue&type=script&lang=js"
export * from "./ListaPaquetesApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports